import { __rest } from "tslib";
import React from "react";
import * as S from "./styles";
export var Banner = function Banner(e) {
  var t = e.url,
      r = e.text,
      a = e.ctaText,
      n = __rest(e, ["url", "text", "ctaText"]);

  return React.createElement(S.Banner, Object.assign({
    "data-testid": "banner"
  }, n), React.createElement(S.Link, {
    href: t
  }, r, React.createElement(S.CTAContainer, null, a ? React.createElement(S.CTAText, null, a) : null, React.createElement(S.RightArrow, null))));
};
export default Banner;